module.exports = __webpack_public_path__ + "img/18.ffaf6088.jpg";